import { useEffect, type RefObject } from 'react';
import { prefersReducedMotion } from './motion-prefs';

/** Параллакс-фото блока «Атмосфера» (портировано из js/main.js, onScroll). */
export function useParallax(sectionRef: RefObject<HTMLElement | null>, bgRef: RefObject<HTMLElement | null>) {
  useEffect(() => {
    if (prefersReducedMotion()) return;
    let raf = 0;
    const update = () => {
      const section = sectionRef.current;
      const bg = bgRef.current;
      if (!section || !bg) return;
      const r = section.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        bg.style.transform = `translateY(${(r.top / window.innerHeight) * -60}px)`;
      }
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        update();
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [sectionRef, bgRef]);
}
